module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/2/5-98f3f2e21947a15141b4472cf542c1d4.jpg";